export default __webpack_public_path__ + "static/media/about-hero.a1266ff8.png";